/**设置firebase跟踪代码 */
const useGtag = true;
export default function (data, event = "screen_view") {
  if (useGtag && window.gtag) {
    let screenName = data["screen_name"];
    if (screenName) {
      data["page_title"] = screenName;
      data["firebase_screen"] = screenName;
      data["firebase_screen_class"] = screenName;
    }
    window.gtag("event", 'screen_view', data);
    return;
  }
  if (window.firebaseAnalytics) {
    let screenName = data["screen_name"];
    if (screenName) {
      firebaseAnalytics.setCurrentScreen(screenName);
    } else {
      firebaseAnalytics.logEvent(event, data);
    }
  }
}
